/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGGCC → M A (Met-Ala).`)
};

const es_translate_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGGCC → M A (Met-Ala).`)
};

const de_translate_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGGCC → M A (Met-Ala).`)
};

const nl_translate_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGGCC → M A (Met-Ala).`)
};

const fr_translate_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGGCC → M A (Met-Ala).`)
};

const it_translate_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGGCC → M A (Met-Ala).`)
};

const pt_br2_translate_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGGCC → M A (Met-Ala).`)
};

const pt_translate_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGGCC → M A (Met-Ala).`)
};

const ja_translate_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGGCC → M A（Met-Ala）。`)
};

const zh_translate_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGGCC → M A（Met-Ala）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_ex1", locale)
	if (locale === "en") return en_translate_ex1(inputs)
	if (locale === "es") return es_translate_ex1(inputs)
	if (locale === "de") return de_translate_ex1(inputs)
	if (locale === "nl") return nl_translate_ex1(inputs)
	if (locale === "fr") return fr_translate_ex1(inputs)
	if (locale === "it") return it_translate_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_translate_ex1(inputs)
	if (locale === "pt") return pt_translate_ex1(inputs)
	if (locale === "ja") return ja_translate_ex1(inputs)
	return zh_translate_ex1(inputs)
};